import React, { Component } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  IconButton,
  Typography,
  Avatar,
  Menu,
  MenuItem
} from "@material-ui/core";
import {
  Menu as MenuIcon,
  AccountCircleOutlined,
  SettingsOutlined,
  LockOutlined
} from "@material-ui/icons";
import { withStyles } from "@material-ui/core/styles";
import { FirebaseContext } from "../../FirebaseInit";
import myStyles from "./Style";

class Nav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      menuPos: null,
      menuOpen: false
    };

    this.toggleMenu = this.toggleMenu.bind(this);
    this.handleSignOut = this.handleSignOut.bind(this);
    this.toggleDialog = this.toggleDialog.bind(this);
  }

  toggleMenu(e) {
    this.setState({ menuOpen: !this.state.menuOpen, menuPos: e.currentTarget });
  }

  toggleDialog(name, title, info) {
    this.props.toggleDialog(name, title, info);
    this.setState({ menuOpen: false, menuPos: null });
  }

  handleSignOut(firebase) {
    firebase
      .db()
      .ref("/status/" + this.props.user.uid)
      .set({
        state: "offline",
        last_changed: firebase.db.ServerValue.TIMESTAMP
      });
    firebase.signOut();
  }

  render() {
    const { classes } = this.props;
    const { menuOpen, menuPos } = this.state;
    const firebase = this.context;
    return (
      <AppBar className={classes.appbar}>
        <Toolbar>
          <IconButton
            color="inherit"
            edge="start"
            onClick={this.props.toggleChatList}
            className={classes.menuBtn}
          >
            <MenuIcon />
          </IconButton>
          <Box flexGrow={1}>
            <Typography className={classes.title} variant="h4" component="h4">
              Yow!
            </Typography>
          </Box>
          <Box display="flex" alignItems="center" alignContent="center">
            <Typography className={classes.username}>
              {this.props.user.displayName}
            </Typography>
            <IconButton onClick={this.toggleMenu} color="inherit">
              <Avatar src={this.props.user.photoURL}>
                {this.props.user.displayName &&
                  this.props.user.displayName.charAt(0).toUpperCase()}
              </Avatar>
            </IconButton>
          </Box>

          <Menu
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "center"
            }}
            transformOrigin={{
              vertical: "top",
              horizontal: "center"
            }}
            anchorEl={menuPos}
            open={menuOpen}
            elevation={4}
            getContentAnchorEl={null}
            keepMounted
            onClose={this.toggleMenu}
            PopoverClasses={{ root: classes.zin }}
          >
            <MenuItem
              onClick={this.toggleDialog.bind(
                this,
                "Profile",
                "Account Info",
                null
              )}
            >
              <AccountCircleOutlined className={classes.menuIcon} />
              Profile
            </MenuItem>
            <MenuItem
              onClick={this.toggleDialog.bind(
                this,
                "Settings",
                "Settings",
                null
              )}
            >
              <SettingsOutlined className={classes.menuIcon} />
              Settings
            </MenuItem>
            <MenuItem onClick={this.handleSignOut.bind(this, firebase)}>
              <LockOutlined className={classes.menuIcon} />
              Sign out
            </MenuItem>
          </Menu>
        </Toolbar>
      </AppBar>
    );
  }
}

Nav.contextType = FirebaseContext;
export default withStyles(myStyles)(Nav);
